








































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import ShiftDto from '@/models/Shifts/ShiftDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import BookAppliedBookingRoleWorkerRequest from '@/models/BookingRoleWorkers/BookAppliedBookingRoleWorkerRequest'
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue';
import BookingRoleWorkerShiftStatusEnum from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';
import ShiftStatus from '@/components/Shifts/Display/ShiftStatus.vue';
import ShiftStatusEnum from '@/models/Shifts/ShiftStatus';
// @ts-ignore
import VCurrencyField from 'v-currency-field';
import { component } from 'vue/types/umd';
import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';
import AvailabilityRestrictionSummary from '@/components/AvailabilityRestrictions/Display/AvailabilityRestrictionSummary.vue';
import CalculatePayRateForBookRequest from '@/models/WorkerPositions/CalculatePayRateForBookRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'BookingManageWorkersBook', 
    components: { ShiftStatus, BookingRoleWorkerShiftStatus, AvailabilityRestrictionSummary }
})
export default class extends GiganautVueDialog {

  @Prop()
  selectedBookingRole: BookingRoleDto;

  public dialog = false;
  public shifts: SelectableEntity<BookingRoleWorkerShiftDto>[] = [];
  //TODO: We would be better off maintaining a collection of BRCS
  public selectedBookingRoleWorkerShiftIds: string[] = [];
  public selectedShiftIds: string[] = [];
  public payRate = 0;
  public minimumPayRate = 0;
  public chargeRate = 0;
  public dialogWidth = 600;
  public workerHasRestriction = false;
  public restrictionCheckRequired = false;
  public columns = "12";

	bookingRoleWorkerShiftStatusEnum = BookingRoleWorkerShiftStatusEnum;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    this.selectedShiftIds = [];
    this.shifts = [];
    this.selectedBookingRoleWorkerShiftIds = []; 
    BookingDetailsModule.offeredWorkersVM.availabilitySummariesForBook = [];  
    if (val) {
      const availableShifts = BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts.filter(function(bookingRoleWorkerShift){
        if (bookingRoleWorkerShift.status === BookingRoleWorkerShiftStatusEnum.BookedUnconfirmed || bookingRoleWorkerShift.status === BookingRoleWorkerShiftStatusEnum.BookedConfirmed || bookingRoleWorkerShift.shift.status === ShiftStatusEnum.Cancelled) {
          return false;
        }
        return true;
      })
      this.shifts =  availableShifts.map(function(shift) {
        return new SelectableEntity<BookingRoleWorkerShiftDto>(shift);
      });

      //Get the latest shift in the list - that means the pay rate will be for the last available shift but not much we can do about that
      let latestShiftDate = this.shifts[0].entity.shift.startAt;
      
      for (let shiftIndex = 0; shiftIndex < this.shifts.length; shiftIndex++) {
        const shift = this.shifts[shiftIndex];
        if (shift.entity.shift.startAt > latestShiftDate) {
          latestShiftDate = shift.entity.shift.startAt
        }
      }

      const payRateForBookRequest = new CalculatePayRateForBookRequest();
      payRateForBookRequest.workerId = BookingDetailsModule.offeredWorkersVM.selectedWorkerId;
      payRateForBookRequest.date = new Date(latestShiftDate).toISOString().substr(0,10);

      await BookingDetailsModule.getWorkerPayRateForBook(payRateForBookRequest)

      this.payRate = BookingDetailsModule.offeredWorkersVM.payRateForBook;
      this.minimumPayRate = BookingDetailsModule.offeredWorkersVM.minimumPayRateForBook;
      this.chargeRate = this.selectedBookingRole.chargeRate;
      this.workerHasRestriction = BookingDetailsModule.offeredWorkersVM.selectedWorker.availabilityRestriction !== AvailabilityRestriction.None;
      if (this.workerHasRestriction) {
        this.workerHasRestriction = true;
        this.restrictionCheckRequired = true;
        this.dialogWidth = 1000;
        this.columns = "6";
      } else {
        this.workerHasRestriction = false;
        this.restrictionCheckRequired = false;
        this.dialogWidth = 600;
        this.columns = "12";
      }
    }
  }

  allShiftsAreBooked() {
    let allBooked = true;
    for (let index = 0; index < this.shifts.length; index++) {
      const shift = this.shifts[index];
      //console.log(shift.entity.status);
      if (shift.entity.status != this.bookingRoleWorkerShiftStatusEnum.BookedUnconfirmed && shift.entity.status !== this.bookingRoleWorkerShiftStatusEnum.BookedConfirmed) {
         allBooked = false;
      }
    }
    return allBooked;
  }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get selectedWorker() {
      return BookingDetailsModule.offeredWorkersVM.selectedWorker;
  }

  async updateSelectedShifts(val: boolean, brcs: BookingRoleWorkerShiftDto) {
    //console.log(JSON.stringify(brcs));
    if (val) {
			  this.selectedBookingRoleWorkerShiftIds.push(brcs.id);
        this.selectedShiftIds.push(brcs.shiftId);
		} else {
			  const brcsIndex = this.selectedBookingRoleWorkerShiftIds.indexOf(brcs.id);
        this.selectedBookingRoleWorkerShiftIds.splice(brcsIndex, 1); 
        const shiftIndex = this.selectedShiftIds.indexOf(brcs.shiftId);
        this.selectedShiftIds.splice(shiftIndex, 1); 
		}
     if (this.selectedBookingRoleWorkerShiftIds.length != 0) {
      if (this.workerHasRestriction) {
        this.restrictionCheckRequired = true;
      } else {
        this.restrictionCheckRequired = false;
      }
    }
	}

  get summaries() {
    return BookingDetailsModule.offeredWorkersVM.availabilitySummariesForBook;
  }
	  
  get isLessThanMinimumPayRate() {
    if (this.minimumPayRate === 0) {
      //Not much we can do about that - don't do the check
      return false;
    }
    return this.payRate < this.minimumPayRate;
  }

  async confirm() { 
    const request = new BookAppliedBookingRoleWorkerRequest();
    request.payRate = this.payRate
    request.chargeRate = this.chargeRate
    request.bookingRoleWorkerShiftIds = this.selectedBookingRoleWorkerShiftIds;
    await BookingDetailsModule.bookAppliedBookingRoleWorker(request);
    await BookingDetailsModule.updateOfferedSelectedBookingRole(this.selectedBookingRole);
    await BookingDetailsModule.updateBookedSelectedBookingRole(this.selectedBookingRole);
    this.dialog = false;
  }

    async check() { 
    await BookingDetailsModule.getWorkerRestrictionSummaryForBook(this.selectedShiftIds);
    this.restrictionCheckRequired = false;
  }
}
